/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ཁ་ཙ་",
        "-2": "ཁ་ཉིམ",
        "0": "ད་རིས་",
        "1": "ནངས་པ་",
        "2": "གནངས་ཚེ",
        "future": {
          "other": "ཉིནམ་ {0} ནང་"
        },
        "past": {
          "other": "ཉིནམ་ {0} ཧེ་མ་"
        }
      },
      "day-narrow": {
        "-1": "ཁ་ཙ་",
        "-2": "ཁ་ཉིམ",
        "0": "ད་རིས་",
        "1": "ནངས་པ་",
        "2": "གནངས་ཚེ",
        "future": {
          "other": "ཉིནམ་ {0} ནང་"
        },
        "past": {
          "other": "ཉིནམ་ {0} ཧེ་མ་"
        }
      },
      "day-short": {
        "-1": "ཁ་ཙ་",
        "-2": "ཁ་ཉིམ",
        "0": "ད་རིས་",
        "1": "ནངས་པ་",
        "2": "གནངས་ཚེ",
        "future": {
          "other": "ཉིནམ་ {0} ནང་"
        },
        "past": {
          "other": "ཉིནམ་ {0} ཧེ་མ་"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "ཆུ་ཚོད་ {0} ནང་"
        },
        "past": {
          "other": "ཆུ་ཚོད་ {0} ཧེ་མ་"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "ཆུ་ཚོད་ {0} ནང་"
        },
        "past": {
          "other": "ཆུ་ཚོད་ {0} ཧེ་མ་"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "ཆུ་ཚོད་ {0} ནང་"
        },
        "past": {
          "other": "ཆུ་ཚོད་ {0} ཧེ་མ་"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "སྐར་མ་ {0} ནང་"
        },
        "past": {
          "other": "སྐར་མ་ {0} ཧེ་མ་"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "སྐར་མ་ {0} ནང་"
        },
        "past": {
          "other": "སྐར་མ་ {0} ཧེ་མ་"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "སྐར་མ་ {0} ནང་"
        },
        "past": {
          "other": "སྐར་མ་ {0} ཧེ་མ་"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "other": "ཟླཝ་ {0} ནང་"
        },
        "past": {
          "other": "ཟླཝ་ {0} ཧེ་མ་"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "other": "ཟླཝ་ {0} ནང་"
        },
        "past": {
          "other": "ཟླཝ་ {0} ཧེ་མ་"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "other": "ཟླཝ་ {0} ནང་"
        },
        "past": {
          "other": "ཟླཝ་ {0} ཧེ་མ་"
        }
      },
      "nu": ["tibt"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "སྐར་ཆ་ {0} ནང་"
        },
        "past": {
          "other": "སྐར་ཆ་ {0} ཧེ་མ་"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "སྐར་ཆ་ {0} ནང་"
        },
        "past": {
          "other": "སྐར་ཆ་ {0} ཧེ་མ་"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "སྐར་ཆ་ {0} ནང་"
        },
        "past": {
          "other": "སྐར་ཆ་ {0} ཧེ་མ་"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "other": "བངུན་ཕྲག་ {0} ནང་"
        },
        "past": {
          "other": "བངུན་ཕྲག་ {0} ཧེ་མ་"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "other": "བངུན་ཕྲག་ {0} ནང་"
        },
        "past": {
          "other": "བངུན་ཕྲག་ {0} ཧེ་མ་"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "other": "བངུན་ཕྲག་ {0} ནང་"
        },
        "past": {
          "other": "བངུན་ཕྲག་ {0} ཧེ་མ་"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "other": "ལོ་འཁོར་ {0} ནང་"
        },
        "past": {
          "other": "ལོ་འཁོར་ {0} ཧེ་མ་"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "other": "ལོ་འཁོར་ {0} ནང་"
        },
        "past": {
          "other": "ལོ་འཁོར་ {0} ཧེ་མ་"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "other": "ལོ་འཁོར་ {0} ནང་"
        },
        "past": {
          "other": "ལོ་འཁོར་ {0} ཧེ་མ་"
        }
      }
    },
    "locale": "dz"
  });
}